import RailsResource from './rails-resource';

export default new class extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'batches',
      ajaxLoader: false
    })
  }

  // GET resources
  all(service) {
    if (!service)
      return super.all();

    return this.get(this.endpoint({
      path: this.route,
      queryParams: [`service=${service}`]
    }));
  }

  updateValues(id, data) {
    return this.post(`${this.url}/${this.resource}/${id}/update-values.json`, false, data);
  }
}